import { useAppConfigContext } from '@/context/AppContext';
import dlv from 'dlv';
import { getEnvValue } from '@/utils/envUtils';

const useFeatureFlags = () => {
  const appConfigContext = useAppConfigContext();
  const isPreProd = getEnvValue('APP_ENV') === 'pre-prod';
  let path = 'state.config.featureFlags';
  if (isPreProd) path += '.pre-prod';
  return dlv(appConfigContext, path, {});
};
export default useFeatureFlags;
